import Dashboard from "../Dashboard";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
function Hotels() {
    library.add(faMapMarkerAlt);
    const [allHotels,setHotelsData]=useState([])
    useEffect(()=>{
      fetch('https://travelapp-8fhf.onrender.com/hotels/').then((result)=>{
        result.json().then((resp)=>{
          setHotelsData(resp)
        })
      })
    });

    return (
      <>
      <Dashboard />
      <section className="featuresWrap hotels">
        {
          allHotels.map((hotel,i)=>
          <Link to={'/Hoteldetails/'+hotel._id} key={i}>
            <div className="hotelWrap" key={i}>
              <picture><img src={hotel.photo[0]} alt="" /></picture>
              <h4>{hotel.name}
              <small><FontAwesomeIcon icon="fa-map-marker-alt" /> {hotel.location}</small></h4>
            </div>
          </Link>
          )
        }
      </section>      
      </>
    );
  }
  
  export default Hotels;